var _line, _line2, _line3, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhiteMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 973,
    height: 958,
    viewBox: "0 0 973 958",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 182.983,
    y1: 811.013,
    x2: 782.983,
    y2: 357.013,
    stroke: "grey",
    strokeWidth: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 184.587,
    y1: 810.204,
    x2: 795.587,
    y2: 630.204,
    stroke: "grey",
    strokeWidth: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 182.17,
    y1: 811.785,
    x2: 778.17,
    y2: 101.785,
    stroke: "grey",
    strokeWidth: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 858,
    r: 99.5,
    fill: "#5676E5",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 873,
    cy: 614,
    r: 99.5,
    fill: "#EFEBE9",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 873,
    cy: 357,
    r: 99.5,
    fill: "#EFEBE9",
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 873,
    cy: 100,
    r: 99.5,
    fill: "#EFEBE9",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteMode);
export default __webpack_public_path__ + "static/media/logo-white-mode.0c5ca933dc14bd85825c8349b2e508ee.svg";
export { ForwardRef as ReactComponent };